// AboutUsBanner.js
import React from 'react';
import './AboutUsBanner.css';

const AboutUsBanner = () => {
  return (
    <div className="about-us-banner-section">
      <div className="about-us-banner-header">
        <h2>Inspired by our Story?</h2>
      </div>
      <div className="about-us-banner-text">
        <p>Take the next step and explore our range of products that have driven our success.</p>
      </div>
      <div className="about-us-banner-button">
        <a href="https://www.pharm-rx.store/products" className="about-us-banner-btn">Explore Our Products</a>
      </div>
    </div>
  );
};

export default AboutUsBanner;
